import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SimpleButton from '../../components/Buttons/SimpleButton/SimpleButton';
import './ErrorPage.scss';
import ErrorImage from './ErrorImage.png';
import PropTypes from 'prop-types';
const TEXT = {
    BACK_TITLE: 'Tilbake',
    CONTENT_TITLE: 'Oi sann... Noe gikk galt',
    GENERIC_ERROR: 'Vi beklager, men tjenesten er for tiden ikke tilgjengelig. Vi jobber hardt for å få den opp og gå igjen.',
};
export const ErrorPage = props => {
    const username = localStorage.getItem('username');
    const isoDate = new Date().toISOString();
    return (_jsx("div", { className: "error-page__container", children: _jsxs("div", { className: "error-page__content-box", children: [_jsx("h1", { children: TEXT.CONTENT_TITLE }), _jsx("img", { src: ErrorImage, alt: "Error", className: "error-page__image" }), _jsx("p", { children: TEXT.GENERIC_ERROR }), _jsxs("p", { children: [_jsx("b", { children: "Timestamp: " }), " ", isoDate] }), username && (_jsxs("p", { children: [_jsx("b", { children: "Username: " }), username] })), _jsxs("p", { children: [_jsx("b", { children: "Event ID: " }), props.eventId] }), _jsxs("p", { children: [_jsx("b", { children: "Message: " }), props.error.message] }), _jsx(SimpleButton, { onClick: () => window.location.replace(window.location.origin), title: TEXT.BACK_TITLE })] }) }));
};
ErrorPage.propTypes = {
    eventId: PropTypes.string.isRequired,
    error: PropTypes.objectOf({
        message: PropTypes.string,
    }),
};
